import { Component, Input } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { RadioOption, TemplateRadioComponent } from "../../templates/template-radio/template-radio.component";

@Component({
  standalone: true,
  selector: "app-prefix-idr",
  imports: [TemplateRadioComponent],
  templateUrl: "./prefix-idr.component.html",
  styleUrl: "./prefix-idr.component.less",
})
export class PrefixIdrComponent extends PrefixComponent<string> {
  @Input()
  public options: RadioOption[];

  public constructor() {
    super();
    this.options = [];
    this.characters = ALLOWED_CHARACTERS["idr"];
  }
}
